import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker, Tooltip } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { RouteComponentProps } from 'react-router-dom';
import { CalendarService } from 'services';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ArrowRightBlack, ArrowLeftBlack, TimeIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Calendar extends React.Component<Props> {

	calendar: any;

	state = {
		holidays: [],
		working_days: [],
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		form: {
			appointment_time: '',
			since_hour: '',
			until_hour: ''
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await CalendarService.get();
		this.setState({
			holidays: res.holidays || [],
			working_days: res.working_days || [],
			form: {
				...this.state.form,
				appointment_time: res.appointment_time || '',
				since_hour: res.since_hour ? moment(res.since_hour,'HH:mm:ss').toDate() : '',
				until_hour: res.until_hour ? moment(res.until_hour,'HH:mm:ss').toDate() : ''
			}
		});
	}

	submit = async () => {
		await CalendarService.save({
			working_days: JSON.stringify(this.state.working_days),
			holidays: JSON.stringify(this.state.holidays),
			...this.state.form,
			since_hour: this.state.form.since_hour && moment(this.state.form.since_hour).format('HH:mm:ss'),
			until_hour: this.state.form.until_hour && moment(this.state.form.until_hour).format('HH:mm:ss'),
		});
		Globals.showSuccess("Se ha guardado correctamente");
	}

	setActive = (index: number) => {
		let working_days: any = [...this.state.working_days];
		working_days[index].status = !working_days[index].status;
		this.setState({
			working_days
		});
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		const holidays: any = this.state.holidays;

		return (
			<div id="client-calendar">
				<div className="form-blue">
					<div className="container-days">
						{
							this.state.working_days?.map((item: any, index: number) => {
								return (
									<button className={ `btn btn-calendar ${ item.status ? 'active' : '' }` } onClick={ () => this.setActive(index) }>
										{ moment().isoWeekday(item?.weekday).format('dddd') }
									</button>
								)
							})
						}
					</div>
					<div className="row" style={{ maxWidth: '450px' }}>
						<div className="col-md-6">
							<div className="container-leyend">
								<div>
									<div className="leyend green"></div>
								</div>
								<p>Días laborables</p>
							</div>
						</div>
						<div className="col-md-6">
							<div className="container-leyend">
								<div>
									<div className="leyend danger"></div>
								</div>
								<p>Días no laborables</p>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className="row row-month">
								<div className="col-lg-6">
									<div className="container-arrow">
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().prevYear();
											this.updateDate();
										} }>
											<img src={ ArrowLeftBlack } />
										</button>
										<h4>{ this.state.currentYear }</h4>
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().nextYear();
											this.updateDate();
										} }>
											<img src={ ArrowRightBlack } />
										</button>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="container-arrow">
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().prev();
											this.updateDate();
										} }>
											<img src={ ArrowLeftBlack } />
										</button>
										<h4>{ this.state.currentMonth }</h4>
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().next();
											this.updateDate();
										} }>
											<img src={ ArrowRightBlack } />
										</button>
									</div>
								</div>
							</div>
							<FullCalendar
								ref={ ref => this.calendar = ref }
						        plugins={[ dayGridPlugin ]}
						        initialView="dayGridMonth"
						        locale="es"
						        dayHeaderContent={ (args: any) => {
						        	return (
						        		<button className="btn day-container day-header">
											<p>{ args.text.substring(0,2) }</p>
					        			</button>
						        	)
						        } }
					        	dayCellContent={ (info) => {
					        		const date: any = moment(info.date).format('YYYY-MM-DD');
					        		const weekday: any = this.state.working_days.find((i: any) => i.weekday == moment(date).isoWeekday());

					        		return (
					        			<button 
						        			disabled={ date <= moment().format('YYYY-MM-DD') || !weekday?.status } 
						        			className={ `btn day-container ${ holidays.indexOf(date) != -1 || !weekday?.status ? 'holiday' : '' }` } 
						        			onClick={ () => {
						        				let holidays: any = [...this.state.holidays];
						        				const index = holidays.indexOf(date);
						        				if (index != -1) {
						        					holidays.splice(index,1);
						        				} 
						        				else {
						        					holidays.push(date);
						        				}
						        				this.setState({
						        					holidays
						        				});
						        			} }>
												<p>{ moment(info.date).format('D') }</p>
					        			</button>
					        		)
					        	} }
						        headerToolbar={{
						        	left: '',
						        	center: '',
						        	right:  ''
						        }}
						    />
						</div>
						<div className="col-md-6">
							<div className="row">
								<div className="col-md-12">
									<Input
										type="number"
										containerStyle={{ marginTop: '20px' }}
										value={ this.state.form.appointment_time }
										name="appointment_time"
										placeholder="Minutos"
										label="Duración promedio de las citas (Minutos)"
										onChange={ (e: any) => this.change(e) } />
								</div>
								<div className="col-md-6">
									<DatePicker
										label="Horario (Desde)"
										placeholder="Hora"
										showTimeSelect={ true }
										showTimeSelectOnly={ true }
										timeCaption="Hora"
										dateFormat="hh:mm a"
										calendarIcon={ TimeIcon }
										value={ this.state.form.since_hour }
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since_hour'
												}
											});
										} }
									/>
								</div>
								<div className="col-md-6">
									<DatePicker
										label="Horario (Hasta)"
										placeholder="Hora"
										showTimeSelect={ true }
										showTimeSelectOnly={ true }
										timeCaption="Hora"
										dateFormat="hh:mm a"
										calendarIcon={ TimeIcon }
										value={ this.state.form.until_hour }
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until_hour'
												}
											});
										} }
									/>
								</div>
							</div>
						</div>
					</div>
					
					<div className="text-center">
						<Button type="submit" onClick={ () => this.submit() }>
							Guardar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Calendar);